import React from 'react';
import OrganizationModal from 'shared/components/OrganizationModal';
import COButton from 'shared/components/COButton';
import WarningIcon from 'assets//ColorIcons/PNG/warning_alert.png';
import styles from './scopeValidationModal.module.scss';
import { validationModal } from 'constants/constants';

interface ValidationModalProps {
  modalStatus: boolean;
  closeModal: () => void;
  message?: string;
}

const ValidationModal: React.FC<ValidationModalProps> = ({
  modalStatus,
  closeModal,
  message = validationModal.MESSAGE,
}) => {
  return (
    <OrganizationModal visible={modalStatus} onClose={closeModal} width={500}>
      <div className={styles.alertContainer}>
        <div className={styles.alertIconContainer}>
          <img src={WarningIcon} alt={validationModal.ALT_TEXT} />
        </div>
        <div className={styles.alertTextContainer}>{message}</div>
        <div className={styles.alertButtonContainer}>
          <COButton
            secondary
            children={validationModal.BUTTON}
            onClick={closeModal}
          />
        </div>
      </div>
    </OrganizationModal>
  );
};

export default ValidationModal;
